var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('img',{attrs:{"src":"https://oss.fjdaze.com/oneKeyCopy1688/pdd/copy/drawer.png"}}),_c('div',{staticClass:"no-data"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }